import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import Navbar from 'components/NavbarUnauthenticated/index';
import Box from 'components/Box';
import {Div} from 'components/primitives/body';
import {DisplaySmaller} from 'components/primitives/display';
import {Header} from 'components/primitives/header';
import {WithConsent} from '../../services/consent/WithConsent';


const Consent = ({title, content}) => {
    return (
        <Div style={{padding: '10px 20px'}}>
            <Header style={{justifyContent: 'center'}}>
                <DisplaySmaller style={{textAlign: 'center'}}>{title}</DisplaySmaller>
            </Header>
            <ReactMarkdown source={content}/>
        </Div>
    );
};

Consent.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired
};


class ConsentPage extends React.Component {
    static propTypes = {
        type: PropTypes.string.isRequired
    };

    render() {
        return (
            <WithConsent type={this.props.type}>
                {({loading, consent}) => {
                    console.log(loading, consent);
                    return (
                        <section className="hero is-fullheight alva-bg">
                            <Navbar/>
                            <Div className="hero-body">
                                <div className="container" style={{maxWidth: '900px'}}>
                                    <div className={'content'}>
                                        <Box>
                                            {loading ? (
                                                <p>Loading...</p>
                                            ) : (
                                                <Consent title={consent.title} content={consent.content}/>
                                            )}
                                        </Box>
                                    </div>
                                </div>
                            </Div>
                        </section>
                    );
                }}
            </WithConsent>
        );
    }
}


export default ConsentPage;
